export const findingPlace = (place: any, property: string) => {
  const arr = Object.entries(place);
  // eslint-disable-next-line no-prototype-builtins
  const findedObject = arr.find((prop: [string, any]) => prop[1].hasOwnProperty(property));
  if (!findedObject) throw new Error(`No property with the name ${property} exist within this object.`);
  return findedObject[1] as any;
};
